import { AlertCircleIcon } from '@hugeicons/core-free-icons';
import cn from 'classnames';

import { IconComponent } from 'components/Icon/IconComponent';

import styles from './ValidationAlert.module.scss';

export const ValidationAlert = ({ show = false, message, className }) => {
  return (
    <div
      className={cn(
        styles.root,
        { [styles.rootHidden]: !show },
        'd-flex align-items-center u-padding--small u-border-radius u-gap',
        className,
      )}>
      <IconComponent
        icon={AlertCircleIcon}
        type="error"
        border={false}
        noBackground={true}
        size="small"
      />
      <div className={cn(styles.contentMessage)}>{message}</div>
    </div>
  );
};
